<!--模板-->
<template>
  <div class="zwcWidth">
    <div class="zwcWidth banner">
      <div class="white_box">
        <!--找回密码-->
        <div v-if="boxShow && passShow == false && emailShow == false">
          <el-form>
            <el-row style="padding: 60px 20px;">
              <p class="text-title" @click="showModule(1)" :class='{active:faceValue}' style="border-right: 1px solid #F2F2F2;">手机号找回</p>
              <p class="text-title" @click="showModule(-1)" :class='{active:faceValue1}'>邮箱找回</p>
            </el-row>
            <div v-if="show">
              <el-form-item style="margin-bottom: 40px;">
                <el-input placeholder="请输入手机号" v-model="telphone" maxlength="11" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="请输入验证码" style="width: 180px; margin-right: 62px;" v-model="code" clearable></el-input>
                <!-- <el-input v-model="input" placeholder="输入验证码" style="width: 70%"  clearable></el-input> -->
                <el-button type="primary" :disabled="d" round :plain="false" @click="smsBtn()" style="border-radius: 0; width: 118px; padding: 12px 0px;">
                  <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
                  <span v-if="!sendMsgDisabled">发送验证码</span>
                </el-button>
              </el-form-item>
              <el-form-item>
                <p class="enter">
                  <el-button type="primary" style="width: 100%" @click="login_btn(telphone)">下一步</el-button>
                </p>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item style="margin-bottom: 40px;">
                <el-input placeholder="请输入邮箱账号" v-model="mailbox" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <p class="enter">
                  <el-button type="primary" style="width: 100%" @click="mailbox1(mailbox)">下一步</el-button>
                </p>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <!--重置密码-->
        <div v-if="passShow">
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">重置密码</div>
            </el-col>
          </el-row>
          <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" class="demo-ruleForm">
            <el-form-item style="margin-bottom: 40px;" prop="pass">
              <el-input type="password" placeholder="请输入登录密码" v-model="ruleForm2.pass" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 40px;" prop="checkPass">
              <el-input type="password" placeholder="请再次输入确认密码" v-model="ruleForm2.checkPass" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <p class="enter">
                <!-- <el-button type="primary" size="medium" style="" @click="register_btn()">下一步</el-button> -->
                <el-button type="primary" @click="submitForm('ruleForm2')">修改</el-button>
                <el-button @click="resetForm('ruleForm2')">重置</el-button>
              </p>
            </el-form-item>
          </el-form>
        </div>
        <!--邮箱-->
        <div v-if="emailShow">
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">邮箱验证</div>
            </el-col>
          </el-row>
          <el-form>
            <el-form-item style="margin-bottom: 40px;">
              <p>验证码已发送到您邮箱（{{mailbox}}）! <br> 请您进入邮箱查看后，请填写"邮箱验证码" <br>如果还没有收到或者发生错误，您可 <span style="color:#FF9631" @click="email_code()">再发送一次?</span></p>
              <el-form-item style="margin-bottom: 40px;">
                <el-input placeholder="请输入邮箱验证码" v-model="mailCode" clearable></el-input>
              </el-form-item>
            </el-form-item>
            <el-form-item>
              <p class="enter">
                <el-button type="primary" size="medium" style="" @click="next_step()">我已验证，下一步</el-button>
              </p>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<!--JS-->
<script>
import { sendSmsToTel, checkTelCode, send, api_emailcode, email, tel } from 'api/apis'
import $ from 'jquery'

export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm2.checkPass !== '') {
          this.$refs.ruleForm2.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      ruleForm2: {
        pass: '',
        checkPass: ''
      },
      rules2: {
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      boxShow: true,
      passShow: false,
      emailShow: false,
      activeName: 'second',
      show: true,
      faceValue: true,
      faceValue1: false,
      telphone: '',
      code: '',
      mailbox: '',
      password: '',
      time: 60, // 发送验证码倒计时
      sendMsgDisabled: false,
      d: false, //控制按钮是否禁止点击
      codeData: '',
      mailCode: '',
      textData: '',
      textType: ''
    }
  },
  methods: {
    next_step () {
      let vm = this;
      api_emailcode({ 'email': vm.mailbox, 'verifyCode': vm.mailCode }).then((res) => {
        if (res.code == '000000') {
          vm.$message.success("验证码成功，请您设置新密码");
          vm.codeData = res.data.code
          vm.passShow = true
          vm.emailShow = false
        } else {
          vm.$message.error("验证失败！请输入正确邮箱验证码！再来下一步");
        }
      })
    },
    submitForm (formName) {
      let vm = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (vm.textType == 'tel') {
            tel({
              'password': vm.ruleForm2.checkPass,
              'code': vm.codeData,
              'value': vm.textData,
              'type': vm.textType
            }).then(res => {
              if (res.code == "000000") {
                vm.$message.success("修改密码成功，请登录");
                vm.$router.push('/login')
              } else {
                vm.$message.error(res.msg);
              }
            });
          } else {
            email({
              'password': vm.ruleForm2.checkPass,
              'code': vm.codeData,
              'value': vm.textData,
              'type': vm.textType
            }).then(res => {
              if (res.code == "000000") {
                vm.$message.success("修改密码成功，请登录");
                vm.$router.push('/login')
              } else {
                vm.$message.error(res.msg);
              }
            });
          }

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    showModule (a) {
      if (a == 1) {
        this.show = true;
        this.faceValue = true;
        this.faceValue1 = false;
      } else {
        this.show = false;
        this.faceValue = false;
        this.faceValue1 = true;
      }
    },
    // 手机号验证下一步
    login_btn (value) {
      let vm = this;
      vm.textType = 'tel'
      vm.textData = vm.telphone
      if (vm.telphone == '' || !(/^1[34578]\d{9}$/.test(vm.telphone)) || vm.telphone.length < 11) {
        vm.$message.error("请输入正确手机号");
        return
      }
      if (vm.code == '') {
        vm.$message.error("请输入正确验证码")
        return
      }
      checkTelCode({ 'telphone': vm.telphone, 'verifyCode': vm.code }).then((res) => {
        if (res.code == '000000') {
          vm.passShow = true
          vm.codeData = res.data.code
        } else {
          vm.$message.error(res.msg);
        }
      })
    },
    // 发送验证码
    smsBtn () {
      let vm = this
      console.log("发送");
      if (vm.telphone == '' || !(/^1[34578]\d{9}$/.test(vm.telphone)) || vm.telphone.length < 11) {
        vm.$message.error("请输入正确手机号");
        return
      }
      vm.sendMsgDisabled = true;
      vm.d = true; //倒计时禁止点击
      let interval = window.setInterval(function () {
        if ((vm.time--) <= 0) {
          vm.time = 60;
          vm.sendMsgDisabled = false;
          vm.d = false;
          window.clearInterval(interval);
        }
      }, 1000);
      sendSmsToTel({ 'telphone': vm.telphone, 'status': '2' }).then((res) => {
        if (res.code == '000000') {
          vm.$message.success("已发送，请查收");
        } else {
          vm.$message.error(res.msg);
          vm.sendMsgDisabled = false;
          vm.d = false;
        }
      })
    },
    email_code (value) {
      vm.textData = vm.mailbox
      vm.textType = 'email'
      let vm = this;
      if (vm.mailbox == '' || !(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(vm.mailbox))) {
        vm.$message.error("请输入正确邮箱号");
        return
      }
      send({ 'email': vm.mailbox }).then((res) => {
        if (res.code == '000000') {
          vm.$message.success("验证码已发送到您的邮箱，请查收");
          vm.emailShow = true
        } else {
          vm.$message.error(res.msg);

        }
      })
    },
    // 邮箱验证，下一步
    mailbox1 (mailbox) {
      let vm = this;
      vm.textData = vm.mailbox
      if (vm.mailbox == '' || !(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(vm.mailbox))) {
        vm.$message.error("请输入正确邮箱号");
        return
      }
      send({ 'email': vm.mailbox }).then((res) => {
        if (res.code == '000000') {
          vm.$message.success("验证码已发送到您的邮箱，请查收");
          vm.emailShow = true
        } else {
          vm.$message.error(res.msg);

        }
      })
    }
  }
}
</script>


<!--css样式-->
<style lang="scss" scoped>
@import '../../scss/commonH5.scss';

/*外层样式*/
.zwcWidth {
  width: 100%;
}
/*内层居中样式*/
.seconedWidth {
  width: 1000px;
  margin: 0 auto;
}

// header头部
#header {
  height: 80px;
  // padding: 30px 0;
}
#header > div:first-child {
  padding-top: 15px;
}
#header img {
  display: block;
  width: 120px;
}

/*手机快速登录*/
.banner {
  background: url(../../../static/images/title/login.jpg) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 640px;
  position: relative;
}
.banner .white_box {
  background-color: #ffffff;
  width: 365px;
  height: 530px;
  position: absolute;
  top: 55px;
  left: 50%;
  border-radius: 10px;
  padding: 0 40px;
}
.white_box .text-title {
  display: inline-block;
  width: 50%;
  text-align: center;
  font-size: 25px;
  float: left;
  box-sizing: border-box;
  cursor: pointer;
}
.white_box .text-title.active {
  /*background-image: -webkit-gradient(linear, 0 0, 0 bottom, from(rgb(252, 96, 12)), to(rgb(207, 7, 57)));*/
  color: #f60;
  /*-webkit-background-clip: text;*/
  /*-webkit-text-fill-color: transparent;*/
}

/* 下-底部 */
.b_base {
  margin: auto;
  display: table;
}
.b_base ul li {
  float: left;
}
.b_base ul li a {
  border-right: 2px solid #b4b4b4;
  padding-right: 5px;
  padding-left: 5px;
  color: #b4b4b4;
  font-size: 12px;
  cursor: pointer;
}
.record {
  text-align: center;
  color: #b4b4b4;
  font-size: 12px;
}

.white_box .grid-content a {
  color: #333333;
  font-size: 16px;
}
.white_box .grid-content a:hover {
  color: #f36000;
}
.grid-content {
  text-align: left;
  font-size: 22px;
  color: #828282;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/login/retrievePwd.vue